(function () {
  'use strict';

  if (window.__ikgCreatorGiftPickerInit) {
    window.__ikgCreatorGiftPickerInit(document);
    return;
  }

  function initializePicker(picker) {
    if (picker.dataset.giftPickerReady === 'true') return;
    picker.dataset.giftPickerReady = 'true';

    var select = picker.querySelector('[data-gift-variant]');
    var field = picker.querySelector('[data-gift-item-field]');
    var trigger = picker.querySelector('[data-gift-trigger]');
    var label = picker.querySelector('[data-gift-trigger-label]');
    var swatch = picker.querySelector('[data-gift-trigger-swatch]');
    var popover = picker.querySelector('[data-gift-popover]');
    if (!select || !field || !trigger || !popover) return;

    function positionPopover() {
      if (!popover.matches(':popover-open')) return;
      var rect = trigger.getBoundingClientRect();
      var pad = 16;
      var width = Math.min(rect.width, Math.max(window.innerWidth - pad * 2, 0));
      var left = Math.min(Math.max(rect.left, pad), Math.max(window.innerWidth - width - pad, pad));
      popover.style.position = 'fixed';
      popover.style.left = left + 'px';
      popover.style.right = 'auto';
      popover.style.bottom = 'auto';
      popover.style.width = width + 'px';
      var height = popover.offsetHeight || 0;
      popover.style.top = window.innerHeight - rect.bottom < height + pad && rect.top > height + pad
        ? rect.top - height - 4 + 'px'
        : rect.bottom + 4 + 'px';
    }

    function sync() {
      var value = String(select.value || '');
      if (value === 'none') picker.dataset.selectedGiftMode = 'none';
      else if (value) picker.dataset.selectedGiftMode = 'add';
      var mode = picker.dataset.selectedGiftMode || '';
      picker.querySelectorAll('[data-gift-mode]').forEach(function (button) {
        var selected = button.dataset.giftMode === mode;
        button.dataset.selected = selected ? 'true' : 'false';
        button.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });
      field.classList.toggle('tw:hidden', mode !== 'add');

      var selectedButton = null;
      picker.querySelectorAll('[data-gift-option]').forEach(function (button) {
        var id = button.dataset.giftOption;
        var available = Array.prototype.some.call(select.options, function (option) { return option.value === id; });
        button.hidden = !available;
        button.style.display = available ? '' : 'none';
        var selected = available && id === value;
        button.dataset.selected = selected ? 'true' : 'false';
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.querySelector('[data-gift-option-check]').classList.toggle('tw:hidden', !selected);
        if (selected) selectedButton = button;
      });
      label.textContent = selectedButton
        ? selectedButton.querySelector('[data-gift-option-label]').textContent.trim()
        : 'Select free item';
      swatch.replaceChildren();
      if (selectedButton) {
        var image = selectedButton.querySelector('img');
        if (image) {
          var preview = image.cloneNode(false);
          preview.className = 'tw:h-full tw:w-full tw:object-contain tw:p-0.5';
          swatch.appendChild(preview);
        }
      }
    }

    function changeValue(value) {
      if (select.value === value) return;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    picker.addEventListener('click', function (event) {
      var modeButton = event.target.closest('[data-gift-mode]');
      if (modeButton && picker.contains(modeButton)) {
        var mode = modeButton.dataset.giftMode;
        picker.dataset.selectedGiftMode = mode;
        if (mode === 'none') {
          if (popover.matches(':popover-open')) popover.hidePopover();
          changeValue('none');
        } else if (select.value === 'none') {
          changeValue('');
        }
        sync();
        if (mode === 'add') trigger.focus();
        return;
      }
      var optionButton = event.target.closest('[data-gift-option]');
      if (optionButton && picker.contains(optionButton) && !optionButton.hidden) {
        changeValue(optionButton.dataset.giftOption);
        if (popover.matches(':popover-open')) popover.hidePopover();
        sync();
        trigger.focus();
      }
    });

    select.addEventListener('change', sync);
    var optionObserver = new MutationObserver(sync);
    optionObserver.observe(select, { childList: true });
    popover.addEventListener('toggle', function (event) {
      var open = event.newState === 'open';
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        positionPopover();
        var first = popover.querySelector('[data-gift-option][data-selected="true"]:not([hidden])')
          || popover.querySelector('[data-gift-option]:not([hidden])');
        if (first) first.focus();
      }
    });
    window.addEventListener('resize', positionPopover);
    window.addEventListener('scroll', positionPopover, true);
    function onSectionUnload(event) {
      if (!event.target.contains(picker)) return;
      optionObserver.disconnect();
      window.removeEventListener('resize', positionPopover);
      window.removeEventListener('scroll', positionPopover, true);
      document.removeEventListener('shopify:section:unload', onSectionUnload);
    }
    document.addEventListener('shopify:section:unload', onSectionUnload);
    sync();
  }

  function initializeWithin(scope) {
    scope.querySelectorAll('[data-creator-gift-picker]').forEach(initializePicker);
  }

  window.__ikgCreatorGiftPickerInit = initializeWithin;
  initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
})();
